import React, { useState } from 'react';
import {
  FaUser, FaEnvelope, FaPhone, FaMapMarkerAlt,
  FaLock, FaKey
} from 'react-icons/fa';
import './RegistrationInfo.css';

const RegistrationInfo = ({ formik, submitForm, loading }) => {
  const [passwordStrength, setPasswordStrength] = useState('');

  const handlePasswordChange = (e) => {
    formik.handleChange(e);
    const pwd = e.target.value;
    if (pwd.length < 6) setPasswordStrength('Weak');
    else if (pwd.length < 10) setPasswordStrength('Moderate');
    else setPasswordStrength('Strong');
  };

  return (
    <div className="form-step">
      <h2>Registration</h2>

      <div className="form-group">
        <label><FaUser /> First Name *</label>
        <input type="text" name="firstName" value={formik.values.firstName} onChange={formik.handleChange} />
        {formik.errors.firstName && <div className="error-text">{formik.errors.firstName}</div>}
      </div>

      <div className="form-group">
        <label><FaUser /> Last Name *</label>
        <input type="text" name="lastName" value={formik.values.lastName} onChange={formik.handleChange} />
        {formik.errors.lastName && <div className="error-text">{formik.errors.lastName}</div>}
      </div>

      <div className="form-group">
        <label><FaEnvelope /> Email *</label>
        <input type="email" name="email" value={formik.values.email} onChange={formik.handleChange} />
        {formik.errors.email && <div className="error-text">{formik.errors.email}</div>}
      </div>

      <div className="form-group">
        <label><FaPhone /> Phone Number *</label>
        <input type="tel" name="phoneNumber" value={formik.values.phoneNumber} onChange={formik.handleChange} />
        {formik.errors.phoneNumber && <div className="error-text">{formik.errors.phoneNumber}</div>}
      </div>

      <div className="form-group">
        <label><FaMapMarkerAlt /> Location *</label>
        <input type="text" name="location" value={formik.values.location} onChange={formik.handleChange} />
        {formik.errors.location && <div className="error-text">{formik.errors.location}</div>}
      </div>

      <div className="form-group">
        <label><FaLock /> Password *</label>
        <input type="password" name="password" value={formik.values.password} onChange={handlePasswordChange} />
        {formik.errors.password && <div className="error-text">{formik.errors.password}</div>}
        {formik.values.password && (
          <div className={`password-strength ${passwordStrength.toLowerCase()}`}>
            Strength: {passwordStrength}
          </div>
        )}
      </div>

      <div className="form-group">
        <label><FaKey /> Confirm Password *</label>
        <input type="password" name="confirmPassword" value={formik.values.confirmPassword} onChange={formik.handleChange} />
        {formik.errors.confirmPassword && <div className="error-text">{formik.errors.confirmPassword}</div>}
      </div>

      <div className="form-actions">
        <button type="button" onClick={submitForm} className="btn-primary" disabled={loading}>
          {loading ? 'Submitting...' : 'Complete Registration'}
        </button>
      </div>
    </div>
  );
};

export default RegistrationInfo;
